<template>
  <div class="col-12 text-center">
    <div class="row">
      <div class="col">
        {{ item.name }}
      </div>
      <div class="col">
        <div class="p-0 m-0" v-for="subscriptionItem in subscriptionItems">

          <div class="row">

            <div class="col-12">
              <del v-if="subscriptionItem.offer > 0">{{ formatNumber(subscriptionItem.price) }} تومان</del>
              <p>{{ formatNumber(subscriptionItem.price_with_offer) }} تومان
                <span v-if="subscriptionItem.offer > 0"
                      class="badge badge-danger rounded-pill">{{ subscriptionItem.offer_percent }} %</span>
              </p>
            </div>


          </div>


        </div>
      </div>
      <div class="col">
        <button @click="chargeSubscription()" class="btn btn-primary btn-rounded payment-button">انتخاب</button>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "RelatedSubscriptionItem",
  props: {
    item: {},
    subscriptionCharge: {},
    gateway: {
      default: 'zarinpal'
    }
  },
  computed: {
    subscriptionItems() {

      let subscriptions = this.item.subscriptions;
      let result = []

      subscriptions.forEach(subitem => {
        let item = subitem.subscription_item
        item['price_with_offer'] = item['price'] - item['offer']
        item['offer_percent'] = 100 - (item['price_with_offer'] * 100) / item['price'];
        result.push(item)
      })

      return result
    }
  },
  methods: {
    formatNumber,
    togglePaymentButtons(mode = 'disable') {
      let paymentButton = document.querySelectorAll('.payment-button')
      paymentButton.forEach(item => {
        if (mode === 'disable') {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      })
    },
    async chargeSubscription() {
      this.togglePaymentButtons('disable');
      let form = {
        user: this.subscriptionCharge.user_id,
        subscriptionCharge: this.subscriptionCharge.id,
        product: this.item.id,
        gateway: this.gateway
      }
      let req = await this.$store.dispatch('Subscription/chargeSubscription', form)

      let data = req.data.data
      let url = data.payment_url

      if (url === 'FREE') {
        await this.$router.push({name: 'verifyTransaction', params: {slug: data.slug}})
      } else {
        window.location.href = url;
      }

      setTimeout(() => {
        this.togglePaymentButtons('enable');
      }, 1000)

    }
  }
}
</script>


<style scoped>

</style>